// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'

// Atoms
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'

export default class LocationEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  updateField = (fieldData) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, fieldData)
      }
    })
  }

  handleLabelSave = (label) => {
    this.updateField({ label })
  }

  handleValueSave = (value) => {
    this.updateField({ value })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  render() {
    const { field } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Where" onDelete={this.handleDelete}>
          <TextInput
            required
            maxLength={50}
            label="Heading"
            placeholder="Type a heading here..."
            defaultValue={field.label || ''}
            onSave={this.handleLabelSave}
          />
          <Spacer small />
          <TextInput
            required
            multiline
            enableLineBreak
            maxLength={100}
            label="Location"
            placeholder="Enter location here..."
            defaultValue={field.value || ''}
            onSave={this.handleValueSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
